
<mat-accordion>
    <mat-expansion-panel #solarPowerExpansionPanel [expanded]="true" (click)="click(solarPowerExpansionPanel, $event)" class="solar-expansion-container">
        <mat-expansion-panel-header>
              <mat-panel-title>
                  
                  <div class="row" style="display: flex; align-items: center; width: 100%">
                      <div class="col-md-2" style="display: flex; align-items: flex-end;">
                          <ng-container *ngIf="icon">
                              <i class="fa fa-sort-asc arrow-expansion-panel-customize asc" aria-hidden="true"></i>
                          </ng-container>
                          <ng-container *ngIf="!icon">
                              <i class="fa fa-sort-desc arrow-expansion-panel-customize desc" aria-hidden="true"></i>
                          </ng-container>
                        <span class="title-header">Trends</span>
                      </div>
                      <div class="col-md-6">
                          <mat-form-field>
                              <mat-select [(ngModel)]="graphTypeSelected" (ngModelChange)="onGraphTypeChange()">
                                  <mat-option *ngFor="let type of graphTypes" [value]="type.value">
                                    {{type.viewValue}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                      </div>
                      <div class="col-md-4">
                          <mat-form-field>
                              <input matInput [matDatepicker]="picker" required [formControl]="date" 
                              (dateInput)="addEvent('input', $event)" (dateChange)="addEvent('change', $event)" [max]="max">
                              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker disabled="false"></mat-datepicker>
                              <mat-error *ngIf="date.invalid">Invalid Date</mat-error>
                            </mat-form-field>
                      </div>
                  </div>
                </mat-panel-title>
        </mat-expansion-panel-header>
        <div id="chartContainer"> 
          <div  [chart]="irradiancechart" class="irradiance-chart" ></div>
            <mat-action-row class="expansion-footer" >
                <p *ngIf="isShowTotal"><strong style="font-size: 12px">Total Irradiation between {{fromDate}} to {{toDate}} is: {{value | number:'1.0-2'}} (kWh/m2)</strong></p>
              </mat-action-row> 
            
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    